"use client";

import React from "react";
import type { IconProps } from "@/components/icons/icons-utils/icon-props";
import { useIconLayout } from "@/components/icons/icons-utils/use-icon-layout";

// MARK: Grid3x3
/**
 * Grid3x3 icon — add SVG markup inside the root `<svg>`.
 *
 * **Reuse scope:** Project-wide — `@/components/icons` registry.
 */
export const Grid3x3: React.FC<IconProps> = (props) => {
    const { resolved_width, resolved_height, effective_stroke_width, className, svg_style, rest } = useIconLayout(props);

    return (
        <svg
            viewBox="0 0 24 24"
            width={resolved_width}
            height={resolved_height}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={svg_style}
            strokeWidth={effective_stroke_width}
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
            {...rest}
        >
            <path d="M21 3V21H3V3H21Z" ></path>
            <path d="M3 16.5H21" ></path>
            <path d="M3 12H21" ></path>
            <path d="M3 7.5H21" ></path>
            <path d="M16.5 3V21" ></path>
            <path d="M12 3V21" ></path>
            <path d="M7.5 3V21" ></path>
        </svg>
    );
};

Grid3x3.displayName = "Grid3x3";
